import { IRoutes } from "@techzyapp/ui-lib";

import { DashboardRoute } from "pages/Dashboard/routes";

// Auth Routes
import { LoginRoute } from "pages/Login/routes";
import { ForgotPasswordRoute } from "pages/ForgotPassword/routes";
import { ResetPasswordRoute } from "pages/ResetPassword/routes";

// Other Routes
import { AccountRoute } from "pages/Account/routes";

// Promotions Routes
import { PartnersRoute } from "pages/Partners/routes";
import { OffersRoute } from "pages/Offers/routes";
import { ProductRoute } from "pages/Products/routes";

// Content Management Routes
import { TextPageRoute } from "pages/TextPages/routes";
import { WidgetConfigRoute } from "pages/WidgetConfig/routes";
import { BannersRoute } from "pages/Banners/routes";

// Loyalty Routes
import { RaffleRoute } from "pages/Raffle/routes";
import { LeaderboardRoute } from "pages/LeaderboardConfigurations/routes";
import { PrizesRoute } from "pages/Prizes/routes";
import { StepsConfigRoute } from "pages/StepsConfig/routes";
import { ChallengesRoute } from "pages/Challenges/routes";
import { PrizeLibraryRoute } from "pages/PrizeLibrary/routes";
import { InfluencersCampaignRoute } from "pages/InfluencersCampaign/routes";

// Instant Win Routes
import { SalesPointRoute } from "pages/InstantWin/SalesPoint/routes";
import { SalesPointGroupRoute } from "pages/InstantWin/SalesPointGroup/routes";
import { InstantWinCampaignRoute } from "pages/InstantWin/Campaign/routes";
import { InstantWinPayoutsRoute } from "pages/InstantWin/Payouts/routes";

// Games Routes
import { GameConfigRoute } from "pages/GameConfig/routes";
import { GamesRoute } from "pages/Games/routes";
import { BlitzQuizRoute } from "pages/BlitzQuiz/routes";

// User Management Routes
import { CustomersRoute } from "pages/Customers/routes";
import { TransactionsRoute } from "pages/Transactions/routes";
import { CustomerExportRoute } from "pages/CustomerExport/routes";

// Code Management Routes
import { CodeGenerationRoute } from "pages/CodeGeneration/routes";
import { CodeCheckerRoute } from "pages/CodeChecker/routes";

// System User Routes
import { SystemUsersRoute } from "pages/SystemUsers/routes";
import { AppUpdateConfigRoute } from "pages/AppUpdateConfig/routes";

// Referral Routes
import { ReferralConfigRoute } from "pages/ReferralConfig/routes";

// Notifications Routes
import { NotificationTemplatesRoute } from "pages/NotificationTemplates/routes";

export const allRoutes: IRoutes = {
  mainPath: "/",
  defaultPath: DashboardRoute.path,
  indexElement: DashboardRoute.element,
  items: [
    DashboardRoute,
    {
      name: "System Users",
      path: "/system-users",
      element: "",
      children: [SystemUsersRoute],
    },
    {
      name: "Promotions",
      path: "/promotions",
      element: "",
      children: [PartnersRoute, OffersRoute, ProductRoute],
    },
    {
      name: "Content Management",
      path: "/content-management",
      element: "",
      children: [TextPageRoute, WidgetConfigRoute, BannersRoute],
    },
    {
      name: "Loyalty",
      path: "/loyalty",
      element: "",
      children: [
        RaffleRoute,
        {
          ...LeaderboardRoute,
          children: [...(LeaderboardRoute.children || []), PrizesRoute],
        },
        StepsConfigRoute,
        BlitzQuizRoute,
        ChallengesRoute,
        PrizeLibraryRoute,
        InfluencersCampaignRoute,
      ],
    },
    {
      name: "Games Management",
      path: "/games-management",
      element: "",
      children: [GameConfigRoute, GamesRoute],
    },
    {
      name: "Instant Win",
      path: "/instant-win",
      element: "",
      children: [
        SalesPointRoute,
        SalesPointGroupRoute,
        InstantWinCampaignRoute,
        InstantWinPayoutsRoute,
      ],
    },
    {
      name: "User Management",
      path: "/user-management",
      element: "",
      children: [CustomersRoute, TransactionsRoute, CustomerExportRoute],
    },
    {
      name: "Notifications",
      path: "/notifications",
      element: "",
      children: [NotificationTemplatesRoute],
    },
    {
      name: "Referral",
      path: "/referral",
      element: "",
      children: [ReferralConfigRoute],
    },
    {
      name: "Code Verification",
      path: "/code-verification",
      element: "",
      children: [CodeCheckerRoute],
    },
    {
      name: "Code Management",
      path: "/code-management",
      element: "",
      children: [CodeGenerationRoute],
    },
    {
      name: "Config",
      path: "/config",
      element: "",
      children: [AppUpdateConfigRoute],
    },
    AccountRoute,
  ],
};

export const authRoutes: IRoutes = {
  mainPath: "/",
  defaultPath: LoginRoute.path,
  indexElement: LoginRoute.element,
  items: [LoginRoute, ForgotPasswordRoute, ResetPasswordRoute],
};
